import { createFileRoute } from '@tanstack/react-router';
import { EmailAccountsSettings } from '@/components/settings/email/EmailAccountsSettings';

export const Route = createFileRoute('/_dashboard/dashboard/settings/email-accounts')({
  component: EmailAccountsSettings,
});
